import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cancel-form',
  templateUrl: './cancel-form.component.html',
  styleUrls: ['./cancel-form.component.scss']
})
export class CancelFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
